import { LegalPage } from './LegalPage';

interface PrivacyRouteProps {
  onBackHome: () => void;
}

export function PrivacyRoute({ onBackHome }: PrivacyRouteProps) {
  return (
    <LegalPage title="Privacy Policy" updated="03/19/2025" onBackHome={onBackHome}>
      <p className="text-foreground">
        Welcome to <span className="font-semibold">Michelangelo.land</span> (&quot;we,&quot;
        &quot;our,&quot; or &quot;us&quot;). We are committed to protecting your privacy and
        ensuring the security of your personal information.
      </p>

      <div>
        <h2 className="text-foreground font-semibold">1. Information We Collect</h2>
        <p className="mt-2">
          We may collect information from you when you use our Services, including:
        </p>
        <ul className="mt-3 list-disc pl-5 space-y-1">
          <li>
            <span className="text-foreground font-medium">Account information</span> (name, surname,
            email, photo)
          </li>
          <li>
            <span className="text-foreground font-medium">Usage data and analytics</span>
          </li>
          <li>
            <span className="text-foreground font-medium">Communication preferences</span>
          </li>
          <li>
            <span className="text-foreground font-medium">Technical information</span> about your
            device and how you use our services
          </li>
        </ul>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">2. How We Use Your Information</h2>
        <p className="mt-2">We use the collected information to:</p>
        <ul className="mt-3 list-disc pl-5 space-y-1">
          <li>Provide and maintain our services</li>
          <li>Improve and personalize your experience</li>
          <li>Communicate with you about updates and changes</li>
          <li>Ensure the security of our platform</li>
        </ul>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">3. Data Security</h2>
        <p className="mt-2">
          We implement appropriate technical and organizational measures to protect your personal
          information against unauthorized access, alteration, disclosure, or destruction.
        </p>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">4. Data Sharing</h2>
        <p className="mt-2">
          We do not sell your personal information. We may share your information with:
        </p>
        <ul className="mt-3 list-disc pl-5 space-y-1">
          <li>
            <span className="text-foreground font-medium">Service providers</span> who assist in our
            operations
          </li>
          <li>
            <span className="text-foreground font-medium">Law enforcement</span> when required by
            law
          </li>
          <li>
            <span className="text-foreground font-medium">Third parties</span> with your explicit
            consent
          </li>
        </ul>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">5. Your Rights</h2>
        <p className="mt-2">You have the right to:</p>
        <ul className="mt-3 list-disc pl-5 space-y-1">
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of marketing communications</li>
        </ul>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">6. Contact Information</h2>
        <p className="mt-2">
          For questions about this Privacy Policy or complaints or claims, please contact us at:
        </p>
        <div className="mt-4 rounded-xl border border-border/70 bg-card/40 p-4">
          <div className="text-foreground font-medium">Michelangelo.land</div>
          <div className="mt-2 text-muted-foreground">
            Attention: Sardo Giacomo
            <br />
            Email:{' '}
            <a
              className="text-foreground underline underline-offset-4"
              href="mailto:sardo@michelangelo.land"
            >
              sardo@michelangelo.land
            </a>
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-foreground font-semibold">7. Changes to This Policy</h2>
        <p className="mt-2">
          We may update this Privacy Policy from time to time. We will notify you of any changes by
          posting the new Privacy Policy on this page and updating the &quot;Last updated&quot;
          date.
        </p>
        <p className="mt-4 text-muted-foreground">
          The following clauses are specifically approved: License to Use Our Services, Paid
          Services, Service Modifications and Access, Disclaimer of Warranties, Limitation of
          Liability, Governing Law, Arbitration Clause, Changes to Terms and Changes to This Policy.
        </p>
      </div>
    </LegalPage>
  );
}
